import { render, staticRenderFns } from "./labelsArea.vue?vue&type=template&id=06626fee&"
import script from "./labelsArea.vue?vue&type=script&lang=js&"
export * from "./labelsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports